export default __webpack_public_path__ + "static/media/ep_20.5f10cfea.png";